import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import FloatingChatButton from '../FloatingChatButton';
import FloatingChat from '../FloatingChat';

const ChatbotWidget = ({ isLoggedIn }) => {
  if (!isLoggedIn) {
    return null;
  }

  return (
    <>
      <FloatingChatButton />
      <FloatingChat />
    </>
  );
};

ChatbotWidget.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoggedIn: !isEmpty(state.auth.loginData),
});

export default connect(mapStateToProps)(ChatbotWidget);
